import { useState } from "react";
import { format, startOfMonth, subMonths } from "date-fns";

import Layout from "@/components/layout/Layout";
import { CashFlowStatementHeader } from "@/components/finance/reports/cash-flow-details-new/Header";
import { ProfitAndLossTable } from "@/components/finance/reports/pnl-report/ProfitAndLossTable";

import type {
  ViewPeriod,
  DisplayCurrency,
} from "@/hooks/finance/cash-flow/useCashFlow";
import { useProfitAndLoss } from "@/hooks/finance/pnl/useProfitAndLoss";

export default function ProfitAndLossReportPage() {
  const today = format(new Date(), "yyyy-MM-dd");
  const sixMonthsAgo = format(startOfMonth(subMonths(new Date(), 5)), "yyyy-MM-dd");

  const [dateFrom, setDateFrom] = useState(sixMonthsAgo);
  const [dateTo, setDateTo] = useState(today);
  const [viewPeriod, setViewPeriod] = useState<ViewPeriod>("monthly");
  const [displayCurrency, setDisplayCurrency] = useState<DisplayCurrency>("ETB");

  const { rows, periodLabels, periodKeys, isLoading } = useProfitAndLoss(
    dateFrom,
    dateTo,
    viewPeriod,
    displayCurrency
  );

  return (
    <Layout>
      <div className="space-y-6 pb-12 animate-in fade-in duration-700">
        <CashFlowStatementHeader
          dateFrom={dateFrom}
          dateTo={dateTo}
          viewPeriod={viewPeriod}
          displayCurrency={displayCurrency}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onViewPeriodChange={setViewPeriod}
          onDisplayCurrencyChange={setDisplayCurrency}
          title="Profit & Loss Report"
          badgeLabel="Accrual P&L · company-wide"
        />


        <ProfitAndLossTable
          rows={rows}
          periodLabels={periodLabels}
          periodKeys={periodKeys}
          isLoading={isLoading}
          displayCurrency={displayCurrency}
        />

        <p className="text-xs text-muted-foreground">
          Accrual basis: all non-rejected expenses are booked on their expense date, spread over
          <span className="font-medium"> coverage months</span> where set, with fixed assets depreciated over 60 months.
          Scope is company-wide (all business units). CP1 / CP2 therefore differ from the Business Unit P&amp;L, which is
          cash basis (paid expenses on payment date) and shows only one business unit's allocated share.
        </p>

      </div>
    </Layout>
  );
}
